import {
    IForUnit,
    IRestriction,
    IRulePenalty,
    ISectorAir,
    ISectorStay,
    ITraveller,
    IValidity
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { LuggageType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { ICancellationKeyword } from "libraries/hotel/components/cancellation-conditions/cancellation-conditions.interface";
import { ITotal } from "libraries/interfaces/ITotal";

export interface ICondition {
    columns: ConditionColumns[];
    lines: IConditionLine[];
}

export interface IConditionLine {
    whenLastToCancelWithoutPenalty?: string;
    sector: IConditionSector;
    traveller?: ITraveller[];
    pricing?: IConditionPricing;
    condition?: IConditionCondition;
}

export enum ConditionColumns {
    sector = 'sector',
    traveller = 'traveller',
    pricing = 'pricing',
    condition = 'conditions'
}

export enum RuleType {
    exchange = 'exchange',
    cancellation = 'cancellation',
    luggage = 'luggage',
}

export interface IConditionSector {
    type: string;
    data: Array<ISectorAir | ISectorStay>;
}

export interface IConditionPricing {
    validity?: IConditionPricingValidity;
    keywords?: ICancellationKeyword[];
    fareType?: string[];
    fareFamily?: string;
    fareBasis?: string;
    company?: string;
    tourCode?: string;
    total?: ITotal[] | ITotal;
}

export interface IConditionPricingValidity {
    dates: IValidity;
    valid: boolean;
}

export interface IConditionCondition {
    cancellation?: IRulePenalty[];
    exchange?: IRulePenalty[];
    luggage?: IConditionLuggage[];
}

export interface IConditionLuggage {
    restriction: IRestriction[];
    in: LuggageType;
    quantity: IForUnit[];
    text?: string;
}

export type TSector = Map<string, ISectorAir | ISectorStay>;
export type TTraveller = Map<string, ITraveller>;